import React, { Component } from 'react'
import { formatCurrency } from '../../../../utils/currency'
import { translation } from '../../../../utils/helpers'
import Line from '../Line'

class EstimationLine extends Component {

  renderExtra (extra) {
    let text = extra.Name
    if (extra.AE || extra.Material) {
      text += ` (${translation('13345')}: ${extra.AE} ; ${translation('13443')}: ${formatCurrency(extra.Material)} ${this.props.currencyCode})`
    }

    return (
      <Line key={'extra_' + extra.OrderEstimationExtraId} text={text} subLine={!this.props.editable} />
    )
  }

  render () {
    let Task = this.props.orderEstimationTask
    let text = ''
    let ae = ''

    if (Task !== undefined && Task !== null) {
      text = Task.TaskName
      ae = Task.AE
    }

    if (Task.Extent && Task.Extent.Type) {
      if (text) text += ' ' + Task.Extent.Type
      else text = Task.Extent.Type
    }

    return (
      <Line
        // renderKey={this.props.renderKey}
        text={text}
        amount={ae}
        onDelete={this.props.onDelete && this.props.onDelete.bind(this, Task.OrderEstimationTaskId)}
        subLine={!this.props.editable}
      >
        {Task.Extras && Task.Extras.map(this.renderExtra.bind(this))}
      </Line>
    )
  }
}

export default EstimationLine



// WEBPACK FOOTER //
// ./src/app/shared/components/Extent/EstimationLine/index.js